import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import transactionBackgroundSrc from '../../../../assets/png/transactions-background.png';
import FeatureModal from '../../../../DesignSystem/FeatureModal/FeatureModal';
import { useUpdateInAppComponent } from '../../../../hooks/mutations/useUpdateInAppComponentsLogs';
import { InAppComponent } from '../../../../hooks/query/useGetInappComponentsLogs';
import { useStore } from '../../../../store';
import { LiliCheckbox, LiliCheckboxSize } from '../../../../DesignSystem/LiliCheckbox/LiliCheckbox';

interface CategorizeCreditCardWarningModalDashboardProps {
  multipleAccounts: boolean;
  onFinished: () => void;
  onCanceled?: () => void;
  transactionDetails: string;
}

const CategorizeCreditCardWarningModalContent = (props: {
  transactionDetails: string;
  dontShowAgain: boolean;
  setDontShowAgain: (isChecked: boolean) => void;
}) => {
  const { transactionDetails, dontShowAgain, setDontShowAgain } = props;
  const { t } = useTranslation();

  return (
    <div className='flex flex-col items-center mb-[20px] mt-[8px]'>
      <div className='flex'>
        <div className='font-metricR text-[16px] text-bw08 text-center'>
          {t('TRANSACTIONS_FACELIFT.SYNC_CARD.CATEGORIZE_WARNING_MODAL.TEXT')}
          <span className='font-metricRSemibold'>{transactionDetails}</span>
          {t('TRANSACTIONS_FACELIFT.SYNC_CARD.CATEGORIZE_WARNING_MODAL.TEXT2')}
        </div>
      </div>
      <div className='flex my-[32px] px-[32px] py-[10px] text-[14px] text-center bg-action00 border-[1px] border-action01 rounded-[8px]'>
        {t('TRANSACTIONS_FACELIFT.SYNC_CARD.CATEGORIZE_WARNING_MODAL.HIGHLIGHTED')}
      </div>
      <div className='flex flex-row w-full items-center gap-[8px]'>
        <LiliCheckbox
          id='dont-show-again-checkbox'
          size={LiliCheckboxSize.SMALL}
          checked={dontShowAgain}
          onCheckedChange={setDontShowAgain}
        />
        <p className='font-metricR text-[14px] text-bw07'>
          {t('TRANSACTIONS_FACELIFT.SYNC_CARD.CATEGORIZE_WARNING_MODAL.DONT_SHOW_AGAIN_MESSAGE')}
        </p>
      </div>
    </div>
  );
};

export const CategorizeCreditCardWarningModalDashboard = (props: CategorizeCreditCardWarningModalDashboardProps) => {
  const { multipleAccounts, onFinished, onCanceled, transactionDetails } = props;
  const { t } = useTranslation();
  const { mutateAsync: updateInAppComponentLogMutation, isLoading } = useUpdateInAppComponent();
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const { customerId } = useStore((state) => state.user);
  const markModalAsShown = () => {
    updateInAppComponentLogMutation({
      customerId,
      body: {
        name: InAppComponent.LINKED_CARD_CATEGORIZE_MODAL,
        doNotShowAgain: true,
      },
    }).then(onFinished);
  };
  const handleOnSubmit = () => {
    if (dontShowAgain) {
      markModalAsShown();
    } else {
      onFinished();
    }
  };

  return (
    <FeatureModal
      id='feature-notice-card-modal'
      title={t('TRANSACTIONS_FACELIFT.SYNC_CARD.CATEGORIZE_WARNING_MODAL.TITLE')}
      content={
        <CategorizeCreditCardWarningModalContent
          transactionDetails={transactionDetails}
          dontShowAgain={dontShowAgain}
          setDontShowAgain={setDontShowAgain}
        />
      }
      buttonText={
        multipleAccounts
          ? t('TRANSACTIONS_FACELIFT.SYNC_CARD.CATEGORIZE_WARNING_MODAL.GOT_IT')
          : t('TRANSACTIONS_FACELIFT.SYNC_CARD.CATEGORIZE_WARNING_MODAL.SYNC_CARD')
      }
      {...(!multipleAccounts
        ? { secondaryButtonText: t('TRANSACTIONS_FACELIFT.SYNC_CARD.CATEGORIZE_WARNING_MODAL.NOT_NOW') }
        : {})}
      onClick={handleOnSubmit}
      image={transactionBackgroundSrc}
      onClickOutside={onCanceled}
      stretchButtons
      isButtonLoading={isLoading}
    />
  );
};
